import { useCallback, useEffect, useState } from 'react';
import moment from 'moment';

import { useHandler } from './useHandler';
import { useRepeatTimeout } from './useRepeatTimeout';
import { useTimeout } from './useTimeout';
import { useDisableAlerts } from './useDisableAlerts';
import { useRemoveTimeoutID } from '../../../actions/alert';
import { useSelector } from 'react-redux';
import { AlertSelector } from '../../../selectors/alert';
import { deepEqual } from '../../../service/utils';

export const useAlert = (type) => {
    const removeTimeoutID = useRemoveTimeoutID();
    const { legId, allowed, interval, timeoutID, nextAlert } = useSelector(AlertSelector[type], deepEqual);
    const disabled = useDisableAlerts({ type, legId, allowed });
    const [needUpdate, toggleNeedUpdate] = useState(nextAlert && moment.utc().diff(nextAlert, 'milliseconds') <= 0);
    const toggleUpdate = useCallback((value) => toggleNeedUpdate(value), []);

    const timeMS = useTimeout();
    const showPointNotification = useHandler(legId, toggleUpdate);
    const startTimeout = useRepeatTimeout(
        {
            type,
            allowed,
            legId,
            timeoutID,
            interval,
            timeMS,
            nextAlert,
        },
        showPointNotification,
        needUpdate,
        toggleUpdate
    );

    useEffect(() => {
        if (!disabled && timeMS !== -1) {
            startTimeout(needUpdate);
        } else {
            removeTimeoutID(legId, type);
        }
    }, [needUpdate, disabled, timeMS, legId, type]);
};
